/*
 * ENANTIODROMIA
 * Display-only integration for the Captain Protection widget.
 *
 * Does not change the cart, checkout, checkbox,
 * or Captain's event handlers.
 */

(function () {
  'use strict';

  if (window.__enantioCaptainSummaryInstalled) return;
  window.__enantioCaptainSummaryInstalled = true;

  let drawer = null;
  let observer = null;
  let frame = 0;

  const formatters = new Map();

  function setText(element, value) {
    if (element && element.textContent !== value) {
      element.textContent = value;
    }
  }

  /*
   * Read the price quoted by Captain.
   * Supports:
   * 3.02
   * 3,02
   * 1,234.56
   * 1.234,56
   */
  function readFee(text) {
    const raw = String(text || '').replace(/[^0-9.,]/g, '');

    if (!/\d/.test(raw)) return null;

    const separator = Math.max(
      raw.lastIndexOf('.'),
      raw.lastIndexOf(',')
    );

    const decimalPlaces =
      separator < 0 ? 0 : raw.length - separator - 1;

    let number;

    if (
      separator >= 0 &&
      decimalPlaces > 0 &&
      decimalPlaces <= 2
    ) {
      number =
        raw.slice(0, separator).replace(/[.,]/g, '') +
        '.' +
        raw.slice(separator + 1);
    } else {
      /*
       * When separators are not decimal separators,
       * only accept groups of three digits.
       */
      if (
        separator >= 0 &&
        !/^\d{1,3}([.,]\d{3})+$/.test(raw)
      ) {
        return null;
      }

      number = raw.replace(/[.,]/g, '');
    }

    const cents = Math.round(Number(number) * 100);

    return Number.isSafeInteger(cents) && cents >= 0
      ? cents
      : null;
  }

  function money(cents, currency) {
    const locale = document.documentElement.lang || 'en';
    const key = locale + ':' + currency;

    if (!formatters.has(key)) {
      formatters.set(
        key,
        new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
          currencyDisplay: 'narrowSymbol'
        })
      );
    }

    return formatters.get(key).format(cents / 100);
  }

  function render() {
    const summary =
      drawer &&
      drawer.querySelector('[data-enantio-summary]');

    if (!summary) return;

    const base = Number(summary.dataset.merchandiseTotal);
    const included = Number(summary.dataset.protectionInCart);
    const original = Number(summary.dataset.protectionOriginal);
    const count = Number(summary.dataset.protectionCount);

    if (
      ![base, included, original, count].every(
        Number.isSafeInteger
      )
    ) {
      return;
    }

    const row = summary.querySelector(
      '[data-enantio-protection-row]'
    );

    const feeOutput = summary.querySelector(
      '[data-enantio-protection-amount]'
    );

    const totalOutput = summary.querySelector(
      '[data-enantio-total]'
    );

    if (!row || !feeOutput || !totalOutput) return;

    const widget = drawer.querySelector('#tm_cart');

    const toggle =
      widget &&
      widget.querySelector('input#tm_switch_btn');

    let selected = count > 0;
    let fee = included;

    if (toggle) {
      /*
       * Use the checkbox's live state.
       * The HTML checked attribute is only its default state.
       */
      selected = toggle.checked;
      fee = 0;

      if (selected) {
        const price = widget.querySelector('.tm_price');
        const quote = readFee(price && price.textContent);

        if (quote === null) {
          if (row.hidden) row.hidden = false;

          setText(feeOutput, 'Updating…');
          setText(totalOutput, 'Updating…');

          return;
        }

        /*
         * If the same protection fee is already in the cart,
         * use its actual net charge.
         *
         * The merchandise base excludes that protection line,
         * preventing it from being counted twice.
         */
        fee =
          count > 0 && quote === original
            ? included
            : quote;
      }
    }

    if (row.hidden !== !selected) {
      row.hidden = !selected;
    }

    try {
      const currency = summary.dataset.currency;

      setText(feeOutput, money(fee, currency));
      setText(totalOutput, money(base + fee, currency));
    } catch (error) {
      /*
       * Do not invent a monetary value if formatting fails.
       */
      setText(totalOutput, 'Updating…');

      console.warn(
        '[ENANTIODROMIA cart summary]',
        error
      );
    }
  }

  function schedule() {
    if (frame) return;

    frame = window.requestAnimationFrame(function () {
      frame = 0;
      render();
    });
  }

  function connect() {
    const next = document.getElementById('drawer-cart');

    if (next !== drawer) {
      if (observer) {
        observer.disconnect();
      }

      drawer = next;

      if (drawer) {
        observer = new MutationObserver(schedule);

        observer.observe(drawer, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: [
            'checked',
            'aria-checked'
          ]
        });
      }
    }

    schedule();
  }

  /*
   * Delegated listeners continue working when Captain
   * replaces its widget HTML.
   */
  document.addEventListener(
    'change',
    function (event) {
      if (
        event.target instanceof Element &&
        event.target.matches(
          '#drawer-cart #tm_switch_btn'
        )
      ) {
        schedule();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      if (
        event.target instanceof Element &&
        event.target.closest(
          '#drawer-cart #tm_cart'
        )
      ) {
        schedule();
      }
    },
    true
  );

  document.addEventListener(
    'theme:cart:change',
    connect
  );

  document.addEventListener(
    'theme:drawer:open',
    connect,
    true
  );

  document.addEventListener(
    'shopify:section:load',
    connect
  );

  window.addEventListener(
    'pageshow',
    connect
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      connect,
      { once: true }
    );
  } else {
    connect();
  }
})();